import React, { Component } from 'react'

import RepairOrderView from './RepairOrderView'

class RepairOrderEditor extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <RepairOrderView {...this.props} />
          </div>
        </div>
      </div>
    )
  }
}

export default RepairOrderEditor



// WEBPACK FOOTER //
// ./src/components/RepairOrderEditor.js